import formDeviceNew from './formDeviceNew';

export default {
  title: 'Device',
  attributeName: 'device',
  getURL: 'devices',
  createURL: 'devices',
  updateURL: 'devices',
  additionaMetadataURL: '',
  removeURL: '',
  canCreate: true,
  idAttribute: 'id',
  sessionParams: [],
  formConfig: [formDeviceNew],
  noArea: true,
  goBack: true,
  idUpdate: true
};
